import { render } from "./IconSave.vue?vue&type=template&id=dfb2251a"
import script from "./IconSave.vue?vue&type=script&lang=ts"
export * from "./IconSave.vue?vue&type=script&lang=ts"
script.render = render

export default script